export default function validateImageDimension(file, error, cb) {
    const minSize = 256;
    const maxSize = 720;
    const image = new Image();
   
    image.onload = () => {
        if(
            (image.width >= minSize && image.width <= maxSize) 
            && 
            (image.height >= minSize && image.height <= maxSize)
        ) {
            cb()
        } else {
            error()
        }
    }

    image.src = URL.createObjectURL(file)
}